<glxy-page [pagePadding]="false">
  <glxy-page-toolbar>
    <glxy-page-title>Loop Post Types</glxy-page-title>
    <glxy-page-actions>
      <a [routerLink]="'./select-event'">
        <button mat-raised-button color="primary">Create Post Type</button>
      </a>
    </glxy-page-actions>
  </glxy-page-toolbar>

  <glxy-page-wrapper widthPreset="full">
    <table mat-table content [dataSource]="dataSource">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Name</th>
        <td mat-cell *matCellDef="let row">
          {{ row.name }}
          <br />
        </td>
      </ng-container>

      <ng-container matColumnDef="channel">
        <th mat-header-cell *matHeaderCellDef>Channel</th>
        <td mat-cell *matCellDef="let row">
          {{ row.channel }}
          <br />
        </td>
      </ng-container>

      <ng-container matColumnDef="functions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row">
          <div class="actions">
            <a mat-icon-button [routerLink]="['./edit', row.typeId]">
              <mat-icon aria-label="Edit" matTooltip="Edit">edit</mat-icon>
            </a>
            <!-- TODO: Delete -->
            <!-- <button mat-icon-button>-->
            <!--   <mat-icon aria-label="Delete" (click)="deleteDialog($event, row)" matTooltip="Delete">delete</mat-icon>-->
            <!-- </button>-->
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" tabindex="-1"></tr>
    </table>

    <mat-paginator
      [pageSize]="dataSource.pageSize$ | async"
      [pageSizeOptions]="[15, 30, 100]"
      [length]="dataSource.totalResults"
      [showFirstLastButtons]="true"
      (page)="dataSource.pageOptionsChanged($event)"
    />

    <div style="clear: both"></div>
  </glxy-page-wrapper>
</glxy-page>
